import React from "react"
import FileExplorer from "@components/enterprise-search/FileExplorer";
import UserLogs from "@components/enterprise-search/UserLogs";
import AnalyticsDashboard from "@components/enterprise-search/AnalyticsDashboard";
import RolesAndPermissions from "@components/enterprise-search/RolesAndPermissions";
import {environment} from '@shared/config/environment';
interface AuditLogComponentProps {
  module: string;
  data: any;
  menuItem: any
}

const EnterpriseSearch = (props: AuditLogComponentProps): React.ReactElement => {
    //console.log(environment?.EnterpriceSearchServer)
    const renderContent = () => {
        switch (props?.menuItem) {
        case 'file_explorer':
            return <FileExplorer />
        case 'dashboard':
            return <AnalyticsDashboard />
        case 'rbac':
            return <RolesAndPermissions />
        case 'logs':
            return <UserLogs />;
        default:
            return <div>Wrong Url</div>;
        }
    };

    return (
        <div>
        {renderContent()}
        </div>
    );
};

export default EnterpriseSearch;
